/* BYG Scroll-Reveal (PRÜFSTAND)
   Blendet .byg-reveal-Elemente beim Scrollen ein (translateY 22px, .7s — via CSS)
   und staggert die Kinder ausgewählter Karten-Grids mit einem Takt je
   Abschnitt (STAGGER_CONTAINERS unten).
   Ausfallsicher: Das CSS versteckt Inhalte nur unter .byg-reveal-armed an <html>,
   und diese Klasse setzt ausschließlich dieses Script. Lädt es nicht, bleibt
   alles sichtbar. Respektiert prefers-reduced-motion, Theme-Editor-sicher.
   Regel: kein .byg-reveal auf Above-the-fold-/LCP-Elemente. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = document.documentElement.classList.contains('shopify-design-mode');

  if (reduced) {
    /* WCAG 2.2.2: Autoplay-Videos in BYG-Sektionen bei reduced-motion stoppen. */
    var stopVideos = function () {
      document.querySelectorAll('.byg-scope video[autoplay]').forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', stopVideos);
    } else {
      stopVideos();
    }
    document.addEventListener('shopify:section:load', stopVideos);
  }

  if (reduced || editor || !('IntersectionObserver' in window)) {
    /* Nicht scharfschalten: Inhalte bleiben ohne Animation sichtbar. */
    return;
  }

  document.documentElement.classList.add('byg-reveal-armed');

  /* ---------- Stagger (Phase 8, Feinschliff Motion) ----------
     Kinder dieser Container blenden nacheinander ein. Opt-in NUR über diese
     Liste — kein Liquid-Markup nötig: das Script hängt .byg-stagger an den
     Container und .byg-reveal-item an dessen direkte Kinder. Die Sektions-CSS
     verstecken Items ausschließlich unter .byg-reveal-armed + .byg-stagger,
     und beide Klassen setzt nur dieses Script → ohne JS bleibt alles sichtbar
     (identisches Ausfallsicher-Muster wie .byg-reveal). */
  /* B3-08 — DER TAKT GEHOERT ZUM ABSCHNITT, NICHT ZUR SEITE.
     Vorher bekamen zwoelf Marken-Zellen und vier Prozess-Schritte
     denselben Versatz von 70 ms. Deshalb wirkte alles gleich: ein
     Raster, das nur ankommen soll, und eine Abfolge, die man mitzaehlen
     soll, liefen im selben Puls.
     Gerechnet: die Markenreihe ist nach 12 x 45 = 540 ms komplett statt
     an der 700-ms-Kappe zu haengen; der Prozess braucht 3 x 110 =
     330 ms und ist dabei als Abfolge lesbar.
     Der Wert landet als data-byg-stagger am Container. Damit kann eine
     Section ihren Takt auch selbst im Markup setzen, ohne dass dieses
     Script sie kennen muss — ein im Markup gesetzter Wert gewinnt. */
  var STAGGER_CONTAINERS = {
    '.byg-brands__grid': 45,    /* M-01 zwoelf Marken-Zellen: nur ankommen */
    '.byg-catalog__grid': 55,   /* M-02 Katalog-Karten */
    '.byg-services__grid': 60,  /* M-03 Service-Karten */
    '.byg-process__grid': 110,  /* M-04 vier Halte: zum Mitzaehlen */
    '.byg-workshop__facts': 50, /* M-05 Prinzipien-Zeile */
    '.byg-faq__list': 50        /* FAQ-Items */
  };
  var STAGGER_STEP_MS = 70;  /* Versatz pro Kind (dezent, 60–90ms) */
  var STAGGER_CAP_MS = 700;  /* Obergrenze: lange Grids warten nicht ewig */

  function staggerChildren(container) {
    var step = parseInt(container.getAttribute('data-byg-stagger'), 10);
    if (!(step > 0)) { step = STAGGER_STEP_MS; }
    var delay = 0;
    Array.prototype.forEach.call(container.children, function (child) {
      if (!child.classList.contains('byg-reveal-item') || child.classList.contains('in')) {
        return;
      }
      window.setTimeout(function () {
        child.classList.add('in');
      }, Math.min(delay, STAGGER_CAP_MS));
      delay += step;
    });
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          if (entry.target.classList.contains('byg-stagger')) {
            staggerChildren(entry.target);
          }
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function observe(root) {
    /* Stagger-Container vorbereiten (idempotent) und beobachten —
       auch Container ohne eigenes .byg-reveal (z. B. Fakten-Chips). */
    Object.keys(STAGGER_CONTAINERS).forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (container) {
        if (container.classList.contains('byg-stagger')) return;
        container.classList.add('byg-stagger');
        if (!container.hasAttribute('data-byg-stagger')) {
          container.setAttribute('data-byg-stagger', STAGGER_CONTAINERS[sel]);
        }
        Array.prototype.forEach.call(container.children, function (child) {
          child.classList.add('byg-reveal-item');
        });
        io.observe(container);
      });
    });
    root.querySelectorAll('.byg-reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(document); });
  } else {
    observe(document);
  }

  /* Theme-Editor bzw. dynamisch nachgeladene Sections wieder anmelden */
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
